export default __webpack_public_path__ + "static/media/44t.cd4e71f2.jpg";